module.exports = __webpack_public_path__ + "static/media/github.a9f7ad3d.svg";